export enum ClassicEditorName {
  Body = "body",
  Notes = "notes",
  References = "references",
}
